export default __webpack_public_path__ + "static/code_realtime_theia-67933551331ed146472406d6e2f2b3d0.png";